/**
 * Implementation of handleEndCall for VideoCallInterface components
 * This is a temporary helper file to fix the call ending notification
 */

import GrayPopupNotification from "../../common/NotificationSystem/GrayPopupNotification";

// For ProStudent version
export const handleEndCallProStudent = (
  streamRef,
  onEndCall,
  participant,
  addNotification,
  wasAutomatic = false
) => {
  // Stop all media tracks when ending the call
  if (streamRef.current) {
    const tracks = streamRef.current.getTracks();
    tracks.forEach((track) => track.stop());
    streamRef.current = null;
  }

  if (onEndCall) onEndCall();

  // Use the gray notification for call endings, with appropriate message
  const message = wasAutomatic
    ? `${participant?.name || "User"} ended the call`
    : `Call with ${participant?.name || "User"} ended`;

  // Create a small delay to ensure the popup shows after state updates
  setTimeout(() => {
    addNotification({
      component: GrayPopupNotification,
      props: {
        message,
        duration: 5000, // Ensure duration is long enough to be seen
        title: "Call Ended", // Add a title for better visibility
      },
    });
  }, 100);
};

// For SCAD Office version
export const handleEndCallScadOffice = (
  streamRef,
  onEndCall,
  participant,
  addNotification
) => {
  // Stop all media tracks when ending the call
  if (streamRef.current) {
    const tracks = streamRef.current.getTracks();
    tracks.forEach((track) => track.stop());
    streamRef.current = null;
  }

  if (onEndCall) onEndCall();

  // Use the gray notification for call endings
  addNotification({
    component: GrayPopupNotification,
    props: {
      message: `Call with ${participant?.name || "User"} ended`,
    },
  });
};
